<template lang="pug">
div
  v-card
    v-alert(type='error' :value='true' v-if='isSaveFailed && error' icon='warning') {{ $t('failedToSave') }} {{ error.response }}

  v-card(:raised='isModified')
    v-list(two-line)
      v-list-tile(avatar)
        v-list-tile-avatar(size='40'): img(:src='$store.getters.cover')
        v-list-tile-content
          v-list-tile-title {{ schoolName }}
          v-list-tile-sub-title {{ schoolId }}
    v-divider
    v-card-text
      .title.mb-3.mt-2(v-t='"resetPassword"')
      v-alert(color='green' v-model='successSnackbar' dismissible icon='check' v-t='"resetPasswordSuccessfully"')
      v-form(ref='form' lazy-validation)
        v-layout(row wrap)
          v-flex(xs12 lg6)
            v-text-field(:label='$t("newPassword")' v-model.trim='password' type='password' :rules='passwordRules' clearable)
            v-text-field(:label='$t("confirmPassword")' v-model.trim='password2' type='password' :rules='password2Rules' clearable)
            .mt-3: small.grey--text(v-t='"passwordRule"')
      v-btn.mt-2(color='primary' depressed @click='submit' :loading='isLoading' :disabled='!isValid || isLoading' v-t='"resetPassword"')
</template>

<script>
import apis from '@/assets/js/apis'
import sha512 from 'js-sha512'
import { formStatus } from '@/mixins/formStatus'
import Loader from '@/components/Loader.vue'

export default {
  name: 'Account',
  metaInfo () {
    return {
      title: this.$t('帳戶'),
    }
  },
  data () {
    return {
      password: '',
      password2: '',
      passwordRules: [
        v => this.checkValid(v) || '',
      ],
      password2Rules: [
        v => this.isSame || this.$t('passwordNotTheSame'),
      ],
    }
  },
  mounted () {

  },
  methods: {
    async submit () {
      if (!this.isValid) return
      const body = {
        password: sha512.sha512(this.password),
        password2: sha512.sha512(this.password2),
      }
      this.isSaving = true
      this.successSnackbar = false
      this.clearError()

      try {
        await apis.login.put(body, this.token)
        this.$emit('success')
        this.isSaving = false
        this.successSnackbar = true
      } catch (e) {
        this.isSaveFailed = true
        this.isSaving = false
        this.error = e
      }
    },
    checkValid (v) {
      return /^[A-Za-z]\w{6,20}$/.test(v)
    },
  },
  computed: {
    schoolName () {
      return this.$store.getters.schoolName
    },
    schoolId () {
      return this.$store.getters.schoolId
    },
    isLoading () {
      return this.isSaving
    },
    isValid () {
      const regexResult = this.checkValid(this.password)
      return regexResult && this.isSame
    },
    isSame () {
      return this.password === this.password2
    },
  },
  components: {
    Loader,
  },
  mixins: [formStatus],
}
</script>

<i18n src="@/lang/views/account.json"></i18n>
